import React, { memo } from 'react';

import Logo from '@/components/Logo';

import style from './style.less';

const Loading = () => {
  return (<div className={style.container}>
    <Logo mini={false} customClass="md:max-h-24"/>
  </div>);
};

export default memo(Loading);
